import App from './App'
import store from './store'
import http from './common/http'
import pinia from "@/store/store"
import * as Pinia from 'pinia';
import uView from "uview-ui";


// #ifndef VUE3
import Vue from 'vue'
Vue.config.productionTip = false
Vue.prototype.http = http
Vue.prototype.$store = store
Vue.use(uView);
App.mpType = 'app'
const app = new Vue({
	store,
	...App
})
app.$mount()
// #endif

// #ifdef VUE3
import {
	createSSRApp
} from 'vue'
import {
	setupFilter
} from "./utils/filter";
import {
	setupCrypto
} from "./utils/crypto";
export function createApp() {
	const app = createSSRApp(App)
	app.use(store);
	app.use(pinia);
	app.config.globalProperties.http = http;

	// 全局过滤器
	setupFilter(app);
	setupCrypto(app);

	return {
		app,
		Pinia
	}
}
// #endif